import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './grade-table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moUser from '@store/user';
import moIndex from '../../store/index';

interface IProps {
  tableHead: any[],
  tableArr: any[],
}
interface IState {}

const GradeTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { tableHead, tableArr } = props;
  const { isLogin } = moUser;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className={[
      "table-555", !isMock ? '' : 'mock-100',
    ].join(' ')}
      style={{ overflowY: 'auto' }}>
      <section className="content-101">
        {tableHead.map((item: any, index: number) => (
          <section key={index} className="row-101">
            <strong>{item.title}</strong>
            {item.child ? (
              <p className="line-101">
                {item.child?.map((child: any, idx: number) => (
                  <b key={idx}>{child}</b>
                ))}
              </p>
            ) : null}
          </section>
        ))}
      </section>
      <section className="content-103">
        {tableArr.map((item: any, index: number) => (
          <section key={index} className="row-103">
            <span className="row-10301">{item.title}</span>
            {item.arr?.map((child: any, idx: number) => (
              <span key={idx}>{child}</span>
            ))}
          </section>
        ))}
      </section>
    </section>
  );
};

export default observer(GradeTable);
